import { Breadcrumb, EventHandler } from "client/CommonComponents"
import { GetStatusIcon } from "client/utils/IconsUtil"

const AssetOrderDetailViewBreadcrumb = (props: any) => {
    return (
        <div className="clearfix breadCrumbBlock mb-2">
            <EventHandler onEvent={props.handleClickBack} data-attribute="AssetOrderDetailViewBredcrumb_Default_EventHandler">
                <div className='backButton mb-sm-2 mb-3'>
                    <span className="fa fa-chevron-left"></span>
                    Back
                </div>
            </EventHandler>
            <div className="breadcrumbList">
                <Breadcrumb items={props?.breadcrumlist} maxDisplayedItems="5"  data-attribute="AssetOrderDetailViewBredcrumb_Default_Breadcrumb" />
            </div>
            <div className="float-right">
                <div className="pending">
                    {props?.iconReturn(props?.orderDetails?.orderStatus)}
                    <span className="pending-approval-text">
                        {GetStatusIcon(props?.orderDetails?.orderStatus)?.status}
                    </span>
                </div>
            </div>
        </div>
    )
}

export default AssetOrderDetailViewBreadcrumb